<div class="timer d-flex justify-content-between">
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div class="timer-number">
      <span class="days">{{ days }}</span>
    </div>
    <div class="timer-label font-weight-bold">Días</div>
  </div>
  <div class="timer-separator">:</div>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div class="timer-number">
      <span class="hours">{{ hours }}</span>
    </div>
    <div class="timer-label font-weight-bold">Horas</div>
  </div>
  <div class="timer-separator">:</div>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div class="timer-number">
      <span class="minutes">{{ minutes }}</span>
    </div>
    <div class="timer-label font-weight-bold">Minutos</div>
  </div>
  <div class="timer-separator">:</div>
  <div class="d-flex flex-column align-items-center justify-content-center">
    <div class="timer-number">
      <span class="seconds">{{ seconds }}</span>
    </div>
    <div class="timer-label font-weight-bold">Segundos</div>
  </div>
</div>
